import { FC } from "react";
import { useNavigate } from "react-router-dom";
import "./NotFoundPage.css";

const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <h1>404</h1>
        <h2>Страница недоступна</h2>
        <p>У вас нет доступа к этой странице или она не существует.</p>

        <button type="button" onClick={() => navigate(-1)}>
          Назад
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;
